import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h5l4 8v-16l4 8h5","key":"svg-0"}]]

const IconWaveSawTool = createReactComponent('outline', 'wave-saw-tool', 'WaveSawTool', __iconNode);

export default IconWaveSawTool;